import { defineAbility } from '@casl/ability';
import abilityMapping from './ability-mapping';

const initialAbility = [{
  action: abilityMapping.module.view.action,
  subject: abilityMapping.module.view.subject
}];

const ability = defineAbility((can) => {
  initialAbility.map((elem) => {
    can(elem.action, elem.subject);
  });
});

export default ability;
